import { Stack, Button, Box, Tooltip, IconButton, List, ListItem, ListItemText, 
    ListItemButton } from '@mui/material';

import { BasicTextFilterForm } from 'components/ui/BasicTextFilterForm';

import NoteAddIcon from '@mui/icons-material/NoteAdd'; // or any other relevant "new" icon
import SearchIcon from '@mui/icons-material/Search';



import { FormDialog } from 'components/ui/FormDialog';
import { IBilling } from 'features/finance/models/Billing';
import { IGroupBilling } from 'features/finance/models/GroupBilling';
import { ITellerOperation } from 'features/finance/models/TellerOperation';
import { useBasicFilterBilling } from 'features/finance/services/Billing';
import { useBasicFilterGroupBilling } from 'features/finance/services/GroupBilling';
import { useBasicFilterTellerOperation } from 'features/finance/services/TellerOperation';
import { currentUserSessionAtom } from 'library/store';
import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

export const QuickActions = () => {

    const { t, i18n } = useTranslation();
    const { language: lg, roleEntities } = useRecoilValue(currentUserSessionAtom);

    const navigate = useNavigate();




    const [openBillingFilter, setOpenBillingFilter] = useState(false);
    const basicFilterBilling = useBasicFilterBilling(
        (event: React.MouseEvent<unknown>, row: IBilling) => {
            const { id, customerName, description, showroomName, amount, currencyCode, isDirectSale } = row;

            navigate( `/sale/${id}`);
            setOpenBillingFilter(false);
        }
    );


    const [openTellerOperationFilter, setOpenTellerOperationFilter] = useState(false);
    const basicFilterTellerOperation = useBasicFilterTellerOperation(
        (event: React.MouseEvent<unknown>, row: ITellerOperation) => {
            const { id, } = row;

            navigate(`/tellerOperation/${id}`);
            setOpenTellerOperationFilter(false);
        }
    );


    const handleNewBilling = async () => {
        
        navigate('/billingCommand/-999');
    }

    const handleNewTellerOperation = async () => {
        
        navigate('/tellerOperation/-999');
    }

    const handleBillingSearch = async () => {
        
        setOpenBillingFilter(true);
    }

    const handleTellerOperationSearch = async () => {
        
        setOpenTellerOperationFilter(true);
    }


    const handleUnvalidatedBillings = async () => {        
        navigate('/batchBilling/95/00');
    }

    const handleNotPaidBillings = async () => {        
        navigate('/batchBilling/10/95');
    }

    const handlePartialyPaidBillings = async () => {        
        navigate('/batchBilling/10/10');
    }

    // 30 is 10 and 95
    const handleUnpaidBillings = async () => {        
        navigate('/batchBilling/10/30');
    }

    

    return (
        <List sx={{ p: 0, '& .MuiListItemButton-root': { transition: 'all 200ms ease', borderRadius: 1.2, my: 0.75, py: 1.2, px: 1.5, '&:hover': { backgroundColor: 'action.hover', transform: 'translateX(4px)', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }, '& .MuiSvgIcon-root': { fontSize: 24, opacity: 0.75 }, '& .MuiListItemText-primary': { fontWeight: 600, fontSize: '0.95rem', color: '#1a1a1a' } } }}>
            {roleEntities.some((re) => ['Billing', 'Sale'].includes(re.entityName)) && (
                <Tooltip title={t("List of unvalidated sales/billings")}>
                    <ListItemButton onClick={handleUnvalidatedBillings}>
                        <NoteAddIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={`${t('Unvalidated sales/billings')}`} />
                    </ListItemButton>
                </Tooltip>
            )}

            {roleEntities.some((re) => ['Billing', 'Sale'].includes(re.entityName)) && (
                <Tooltip title={t("List of unpaid sales/billings")}>
                    <ListItemButton onClick={handleUnpaidBillings}>
                        <NoteAddIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={`${t('Unpaid sales/billings')}`} />
                    </ListItemButton>
                </Tooltip>
            )}

            {/* {roleEntities.some((re) => ['Billing', 'Sale'].includes(re.entityName) ) && (
                <Tooltip title={t("New Billing/Sale")}>
                    <ListItemButton onClick={handleNewBilling}>
                        <NoteAddIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={t('New Billing/Sale')} />
                    </ListItemButton>
                </Tooltip>
            )} */}

            {roleEntities.some((re) => ['BillingCommand'].includes(re.entityName) ) && (
                <Tooltip title={t("New Command")}>
                    <ListItemButton onClick={handleNewBilling}>
                        <NoteAddIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={t('New Billing/Sale')} />
                    </ListItemButton>
                </Tooltip>
            )}

            {roleEntities.some((re) => ['Billing', 'Sale'].includes(re.entityName) ) && (
                <Tooltip title={t("Search Billing/Sale")}>
                    <ListItemButton onClick={handleBillingSearch}>
                        <SearchIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={t("Search Billing/Sale")} />
                    </ListItemButton>
                </Tooltip>
            )}

            {roleEntities.some((re) => re.entityName === "TellerOperation") && (
                <Tooltip title={t("New teller operation")}>
                    <ListItemButton onClick={handleNewTellerOperation}>
                        <NoteAddIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={t("Teller operation")} />
                    </ListItemButton>
                </Tooltip>
            )}

            {roleEntities.some((re) => re.entityName === "TellerOperation") && (
                <Tooltip title={t("Search teller operation")}>
                    <ListItemButton onClick={handleTellerOperationSearch}>
                        <SearchIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={t("Search teller operation")} />
                    </ListItemButton>   
                </Tooltip>
            )}

            
            {/* <Button variant="outlined">Submit Claim</Button> */}

            {openBillingFilter && <FormDialog open={openBillingFilter} maxWidth='md'
                okText='' cancelText='' title={`${t('Billing')}(s)`} onCancel={() => { }}
                onClose={() => { setOpenBillingFilter(false); }} onOk={() => { setOpenBillingFilter(false); }}  >
                <BasicTextFilterForm<IBilling> {...basicFilterBilling} />
            </FormDialog>}
            {openTellerOperationFilter && <FormDialog open={openTellerOperationFilter} maxWidth='md'
                okText='' cancelText='' title={t('TellerOperation')} onCancel={() => { }}
                onClose={() => { setOpenTellerOperationFilter(false); }} onOk={() => { setOpenTellerOperationFilter(false); }}  >
                <BasicTextFilterForm<ITellerOperation> {...basicFilterTellerOperation} />
            </FormDialog>}
            
        </List>
    );

}